import { render, staticRenderFns } from "./BindDriver.vue?vue&type=template&id=21772f1e&scoped=true"
import script from "./BindDriver.vue?vue&type=script&lang=js"
export * from "./BindDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21772f1e",
  null
  
)

export default component.exports